import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'emptyField', 'name', 'filledField'];

  connect () {
    if (this._hasDocumentName() || this.inputTarget.files[0]) this.showFileNameAndFilledIcon();
    this.inputTarget.addEventListener('clear', (event) => { this._onClear(event); });
  }

  showFileNameAndFilledIcon () {
    this.emptyFieldTarget.classList.add('d-none');
    this.filledFieldTarget.classList.remove('d-none');
    if (this.inputTarget.files[0]) { this.nameTarget.textContent = this.inputTarget.files[0].name; }
  }

  hideFileNameAndFilledIcon () {
    this.emptyFieldTarget.classList.remove('d-none');
    this.filledFieldTarget.classList.add('d-none');
    this.nameTarget.textContent = '';
  }

  _onClear (_) {
    this.hideFileNameAndFilledIcon();
  }

  _hasDocumentName () {
    return (this.nameTarget.innerText.trim().length > 0);
  }
}
